import urlJoin from "url-join";
import stipulate, { resolveUrl } from "stipulate";

import { baseUrl, baseOptions } from "./base";

export const domainOwnershipVerificationStatus = function(options, query) {
  let url = urlJoin(baseUrl, "pb/domain-ownership-verification-status/");
  if (options.apiUrl) {
    url = options.apiUrl + url;
  }
  url = resolveUrl(url, query);

  let fetchOptions = baseOptions;

  if (options.credentials) {
    fetchOptions = Object.assign({}, baseOptions, {
      credentials: options.credentials
    });
  }

  return stipulate(url, fetchOptions);
};

export default domainOwnershipVerificationStatus;
